import { styled } from '@material-ui/core/styles'
import React from 'react'

import { redirectToDashboard } from 'helpers/miscellaneous'

import './NotFound.css'

import useHeight from '../../hooks/useHeight/useHeight'

const Container = styled('div')({
    display: 'grid',
    gridTemplateRows: 'auto 1fr',
    font: 'Avenir',
})

const Main = styled('main')({
    overflow: 'unset',
    height: '100vh',
})

export default function NotFound(props) {
    const { err } = props
    const height = useHeight()

    console.count('NotFound Component')

    return (
        <Container style={{ height }}>
            <Main>
                <div className="headerimg">
                    <img src="/assets/oh_full.svg" alt="openhouse" />
                </div>
                <div className="notfound">
                    <div className="lostMessage">
                        <div className="msg">
                            <div>hey, looks like you are lost!</div>
                            {err ? (
                                <div className="secondline">{err}</div>
                            ) : (
                                <div className="secondline">
                                    this page does not exist
                                </div>
                            )}
                        </div>
                        <div className="dashboard">
                            <span>click here to go back to your friends</span>
                            <button
                                className="dash-btn"
                                onClick={() => redirectToDashboard()}
                            >
                                go to Dashboard
                            </button>
                        </div>
                    </div>
                    <div className="notfoundimg">
                        <img src="/assets/404.svg" alt="404" />
                    </div>
                </div>
            </Main>
        </Container>
    )
}
